import { Component, Input } from '@angular/core';
import { NgFor } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { PQRNumeroDiasLetivosDto } from '../../dtos/pqr-numero-dias-letivos.dto';

@Component({
  selector: 'app-dialog-pqr-padrao-numero-de-dias',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, NgFor, TabelaComponent],
  templateUrl: './dialog-pqr-padrao-numero-de-dias.component.html',
  styleUrl: './dialog-pqr-padrao-numero-de-dias.component.scss',
})
export class DialogPqrPadraoNumeroDeDiasComponent {
  @Input() pqrNumeroDiasLetivosPadrao: PQRNumeroDiasLetivosDto[] = [];
}
